import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { withRouter } from "routerCompat";
import CommentView from "./CommentView";

class CommentProduct extends React.Component {
  state = {
    open: false,
  };

  render() {
    const recommendStatus = {
      0: {
        color: "#FF4C4C",
        text: "پیشنهاد نمیکنم",
        image: "/public/assets/dislik.svg",
      },
      1: {
        color: "#33AA57",
        text: "پیشنهاد میکنم",
        image: "/public/assets/finger.svg",
      },
      2: {
        color: "#F7A600",
        text: "مطمعن نیستم",
        image: "/public/assets/alamat.svg",
      },
    };

    return (
      <main className='CommentProductMain'>
        {this.state.open ? (
          <CommentView
            comments={this.props.comments}
            avg_rate={this.props.avg_rate}
            modalToggler={this.modalToggler}
          />
        ) : (
          <>
            <div
              className='CommentProductHead'
              onClick={this.props.modalToggler}>
              <span>دیدگاه مشتریان در مورد کالا</span>
              <div className='Opinion'>
                <span>{this.props.comments.length} دیدگاه</span>
                <img src='/public/assets/icons/anotherVendors.svg' alt='pic' />
              </div>
            </div>
            {this.props.comments.length ? (
              <Swiper className='myCommentProduct' slidesPerView={1.4}>
                {this.props.comments.map((comment) => (
                  <SwiperSlide className='MySwiperComment'>
                    <div className='Head'>
                      <img
                        src={recommendStatus[comment.is_recommended].image}
                        alt='pic'
                      />
                      <span>
                        {recommendStatus[comment.is_recommended].text}
                      </span>
                    </div>
                    <p>{comment.text}</p>
                    <div className='Bottom'>
                      <span>{comment.name}</span>
                      <span className='Bullet'>&#8226;</span>
                      <span>{comment.time}</span>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <div className='emptySection'>
                <span className='emptyText'> 
                  هیج دیدگاهی برای این کالا وجود ندارد
                </span>
              </div>
            )}
          </>
        )}
      </main>
    );
  }
}

export default withRouter(CommentProduct);
